import React, { useState, useEffect } from 'react';
import Modal from '../../../common/components/Modal/modal';
import KYCImage from '../../../images/icons/KYCComplete.svg';
import { useFormikContext } from 'formik';
import { navigate } from 'gatsby';

const KYCSuccessPopUp = ({ itsConsumer }) => {
  const { values } = useFormikContext();
  const [show, setShow] = useState('');
  return (
    <React.Fragment>
      <Modal show={true} noCloseBtn={false} setShow={setShow}>
        <div className="w-full  px-4">
          <div className="w-full py-10">
            <p className="font-roboto font-medium mr-auto text text-green-600 text-xl">
              Hey {values?.name() || ''}
            </p>
          </div>
          <div className="w-full">
            <p className="text-orange-600 font-roboto font-bold py-2">
              Congratulations!
            </p>
            <p className="text-black-400 font-roboto font-normal py-2">
              Your KYC process has been completed
            </p>
            <p className="text-black-0 font-roboto font-normal my-4 text-sm">
              You are now only 2 steps away from your Provisional Sanction
              Letter
            </p>
            <div className="">
              <img className="mx-auto" src={KYCImage} />
            </div>
            <div className="">
              <button
                type="submit"
                className="submitButton"
                onClick={() => {
                  if (itsConsumer) {
                    navigate(`/user/income`);
                  } else {
                    values.step && values.step == 'lap'
                      ? navigate(`/app/credit-report?step=lap`)
                      : navigate(`/app/credit-report`);
                  }
                }}
              >
                Add Income Details
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default KYCSuccessPopUp;
